/* eslint-disable curly */
export const mailIsValid = mail => {
    const rgx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
    return rgx.test(String(mail).toLowerCase());
};

const testCPF = strCPF => {
    var Soma;
    var Resto;
    Soma = 0;
    if (strCPF == '00000000000') return false;
    if (strCPF == '11111111111') return false;
    if (strCPF == '22222222222') return false;
    if (strCPF == '33333333333') return false;
    if (strCPF == '44444444444') return false;
    if (strCPF == '55555555555') return false;
    if (strCPF == '66666666666') return false;
    if (strCPF == '77777777777') return false;
    if (strCPF == '88888888888') return false;
    if (strCPF == '99999999999') return false;

    for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
};

export const cpfIsValid = cpf => {
    const cpfToCheck = cpf.replace(/[^0-9]+/g, '');
    const cpfIsValid = testCPF(cpfToCheck);
    // eslint-disable-next-line no-useless-escape
    const rgx = /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/g;
    return rgx.test(String(cpf).toLowerCase()) && cpfIsValid;
};



// WEBPACK FOOTER //
// ./src/utils/user-utils.js